(function () {
  const selectors = {
    root: "[data-complementary-products]",
    item: "[data-complementary-product]",
    selectorLabel: "[data-complementary-selector]",
    toggle: "[data-complementary-toggle]",
    variantInput: "[data-complementary-variant-select]",
    productJson: "[data-complementary-product-json]",
    sizePicker: "[data-complementary-size-picker]",
    sizeToggle: "[data-complementary-size-toggle]",
    sizeList: "[data-complementary-size-list]",
    sizeOption: "[data-complementary-size-option]",
    colorPicker: "[data-complementary-color-picker]",
    colorToggle: "[data-complementary-color-toggle]",
    colorList: "[data-complementary-color-list]",
    colorOption: "[data-complementary-color-option]",
    price: "[data-complementary-price]",
    priceCurrent: "[data-complementary-price-current]",
    priceCompare: "[data-complementary-price-compare]",
    effectiveDiscountBadge: "[data-complementary-effective-discount-badge]",
    effectiveDiscountPercent: "[data-complementary-effective-discount-percent]",
    mobilePrice: "[data-complementary-mobile-price]",
    image: "[data-complementary-product-image]",
    titleSoldOut: "[data-complementary-title-sold-out]",
    selectedSizeLabel: "[data-complementary-selected-size-label]",
    selectedColorLabel: "[data-complementary-selected-color-label]",
    mobileColorLabel: "[data-complementary-mobile-color-label]",
    selectedColorSwatch: "[data-complementary-selected-color-swatch]",
  };

  const totalSelectors = {
    wrapper: "[data-add-to-cart-total]",
    count: "[data-add-to-cart-item-count]",
    comparePrice: "[data-add-to-cart-compare-price]",
    stockWarning: "[data-complementary-stock-warning]",
    totalPrice: "[data-add-to-cart-total-price]",
  };

  const stockWarningText = "Some of the add-on products are out of stock";

  function productVariantPrice(variant) {
    return Number(variant && variant.final_price_active ? variant.final_price : variant && variant.price || 0);
  }

  function displayVariantPrice(variant) {
    const price = productVariantPrice(variant);
    return window.NelpandaFinalPrice?.applyOrderDiscount(price, undefined, variant?.product_discount_eligible !== false) ?? price;
  }

  function displayVariantCompareAtPrice(variant) {
    return Number(variant && variant.final_price_active ? variant.final_compare_at_price : variant && variant.compare_at_price || 0);
  }

  function displayVariantEffectiveDiscountPercent(variant) {
    const productPrice = productVariantPrice(variant);
    const price = displayVariantPrice(variant);
    const compareAtPrice = displayVariantCompareAtPrice(variant);
    const referencePrice = compareAtPrice > productPrice ? compareAtPrice : productPrice;
    return referencePrice > price ? Math.round((referencePrice - price) / referencePrice * 100) : 0;
  }

  function normalizeOptionValue(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function optionMatches(a, b) {
    return normalizeOptionValue(a) === normalizeOptionValue(b);
  }

  function parseProductData(item) {
    if (!item) return null;
    if (item._complementaryProductData) return item._complementaryProductData;

    const script = item.querySelector(selectors.productJson);
    if (!script) return null;

    try {
      item._complementaryProductData = JSON.parse(script.textContent);
      return item._complementaryProductData;
    } catch (error) {
      console.warn("Unable to parse complementary product data", error);
      return null;
    }
  }

  function safeOptionSelector(value) {
    if (window.CSS && typeof window.CSS.escape === "function") return CSS.escape(value || "");
    return String(value || "").replace(/["\\]/g, "\\$&");
  }

  function optionPositionFromPicker(item, selector) {
    const picker = item.querySelector(selector);
    const position = picker ? Number(picker.dataset.complementaryOptionPosition) : 0;
    return Number.isFinite(position) ? position : 0;
  }

  function variantOption(variant, optionPosition) {
    if (!variant || !optionPosition) return "";
    if (Array.isArray(variant.options)) return variant.options[optionPosition - 1] || "";
    return variant[`option${optionPosition}`] || "";
  }

  function selectedSize(item) {
    const picker = item.querySelector(selectors.sizePicker);
    return picker ? picker.dataset.complementarySizeValue || "" : "";
  }

  function selectedColor(item) {
    const picker = item.querySelector(selectors.colorPicker);
    return picker ? picker.dataset.complementaryColorValue || "" : "";
  }

  function findVariant(item, sizeValue, colorValue) {
    const productData = parseProductData(item);
    if (!productData || !Array.isArray(productData.variants)) return null;

    const sizePosition = optionPositionFromPicker(item, selectors.sizePicker);
    const colorPosition = optionPositionFromPicker(item, selectors.colorPicker);

    return productData.variants.find((variant) => {
      const matchesSize = !sizePosition || !sizeValue || optionMatches(variantOption(variant, sizePosition), sizeValue);
      const matchesColor = !colorPosition || !colorValue || optionMatches(variantOption(variant, colorPosition), colorValue);
      return matchesSize && matchesColor;
    });
  }

  function findVariantById(item, variantId) {
    const productData = parseProductData(item);
    if (!productData || !Array.isArray(productData.variants)) return null;

    return productData.variants.find((variant) => String(variant.id) === String(variantId)) || null;
  }

  function findAvailableVariant(item, preferredSize, preferredColor) {
    const exact = findVariant(item, preferredSize, preferredColor);
    if (exact) return exact;

    const productData = parseProductData(item);
    if (!productData || !Array.isArray(productData.variants)) return null;

    const sizePosition = optionPositionFromPicker(item, selectors.sizePicker);
    const colorPosition = optionPositionFromPicker(item, selectors.colorPicker);

    return (
      productData.variants.find((variant) => {
        const matchesSize = !sizePosition || !preferredSize || optionMatches(variantOption(variant, sizePosition), preferredSize);
        const matchesColor = !colorPosition || !preferredColor || optionMatches(variantOption(variant, colorPosition), preferredColor);
        return variant.available && matchesSize && matchesColor;
      }) ||
      productData.variants.find((variant) => variant.available) ||
      productData.variants[0] ||
      null
    );
  }

  function stripTrailingZeroDecimals(formattedPrice) {
    return String(formattedPrice || "").replace(/([.,])00(?=(?:\s|&nbsp;)?[^\d]*$)/, "");
  }

  function formatPrice(cents) {
    if (typeof window.formatMoney === "function") {
      return stripTrailingZeroDecimals(window.formatMoney(cents, window.MinimogSettings && window.MinimogSettings.money_format));
    }

    const amount = Number(cents || 0) / 100;
    return amount.toLocaleString(undefined, {
      style: "currency",
      currency: window.Shopify?.currency?.active || "USD",
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
  }

  function variantImage(variant) {
    if (!variant || !variant.featured_image) return null;
    return variant.featured_image.src || variant.featured_image.url || null;
  }

  function updateOptionAvailability(option, available) {
    option.classList.toggle("is-sold-out", !available);
    option.dataset.available = available ? "true" : "false";
    option.disabled = false;
    option.removeAttribute("aria-disabled");
  }

  function closeList(toggle, list) {
    if (toggle) toggle.setAttribute("aria-expanded", "false");
    if (list && list.hasAttribute("data-complementary-inline-list")) return;
    if (list) list.hidden = true;
  }

  function closeAllLists(except) {
    document.querySelectorAll(`${selectors.sizeList}, ${selectors.colorList}`).forEach((list) => {
      if (list === except) return;
      if (list.hasAttribute("data-complementary-inline-list")) return;
      const item = list.closest(selectors.item);
      const toggle = item && item.querySelector(list.matches(selectors.sizeList) ? selectors.sizeToggle : selectors.colorToggle);
      closeList(toggle, list);
    });
  }

  function toggleList(toggle, list) {
    if (!toggle || !list) return;
    const willOpen = toggle.getAttribute("aria-expanded") !== "true";
    closeAllLists(list);
    toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
    list.hidden = !willOpen;
  }

  function updateSelectedSize(item, sizeValue) {
    const picker = item.querySelector(selectors.sizePicker);
    if (!picker) return;

    picker.dataset.complementarySizeValue = sizeValue || "";
    const label = picker.querySelector(selectors.selectedSizeLabel);
    if (label) label.textContent = sizeValue || "";

    picker.querySelectorAll(selectors.sizeOption).forEach((option) => {
      option.setAttribute("aria-selected", optionMatches(option.dataset.optionLabel, sizeValue) ? "true" : "false");
    });
  }

  function swatchValueFromOption(option) {
    return option ? option.dataset.optionSwatch || "" : "";
  }

  function swatchFocalPointFromOption(option) {
    return option ? option.dataset.optionSwatchFocalPoint || "" : "";
  }

  function updateSelectedColor(item, colorValue, swatchValue, swatchFocalPoint) {
    const picker = item.querySelector(selectors.colorPicker);
    if (!picker) return;

    picker.dataset.complementaryColorValue = colorValue || "";

    const label = picker.querySelector(selectors.selectedColorLabel);
    if (label) label.textContent = colorValue || "";

    const mobileLabel = item.querySelector(selectors.mobileColorLabel);
    if (mobileLabel) mobileLabel.textContent = colorValue || "";

    const selectedSwatch = picker.querySelector(selectors.selectedColorSwatch);
    if (selectedSwatch && swatchValue) {
      selectedSwatch.style.setProperty("--swatch-background", swatchValue);
      if (swatchFocalPoint) {
        selectedSwatch.style.setProperty("--swatch-focal-point", swatchFocalPoint);
      } else {
        selectedSwatch.style.removeProperty("--swatch-focal-point");
      }
    }

    picker.querySelectorAll(selectors.colorOption).forEach((option) => {
      const selected = optionMatches(option.dataset.optionLabel, colorValue);
      option.setAttribute("aria-selected", selected ? "true" : "false");
      option.setAttribute("aria-checked", selected ? "true" : "false");
    });
  }

  function updateSelectedState(item) {
    if (!item) return;

    const toggle = item.querySelector(selectors.toggle);
    const selected = !!(toggle && toggle.checked && !toggle.disabled);
    const unavailableSelected = selected && item.dataset.available === "false";
    const selectorLabel = item.querySelector(selectors.selectorLabel);

    item.classList.toggle("is-selected", selected);
    item.classList.toggle("is-unavailable-selected", unavailableSelected);
    if (selectorLabel) selectorLabel.setAttribute("aria-expanded", selected ? "true" : "false");
  }

  function updateAvailability(item, variant) {
    const available = !!(variant && variant.available);
    const productData = parseProductData(item);
    const hasAvailableVariant = !!(
      productData &&
      Array.isArray(productData.variants) &&
      productData.variants.some((candidate) => candidate.available)
    );
    const toggle = item.querySelector(selectors.toggle);
    const variantInput = item.querySelector(selectors.variantInput);
    const checkboxLabel = toggle && toggle.closest(".product-complementary-products__checkbox");
    const soldOutLabel = item.querySelector(selectors.titleSoldOut);

    if (toggle) {
      toggle.disabled = !hasAvailableVariant;
      if (!hasAvailableVariant) toggle.checked = false;
    }
    if (variantInput) {
      variantInput.disabled = !available;
      if (variant) variantInput.value = variant.id;
    }
    if (checkboxLabel) checkboxLabel.classList.toggle("is-disabled", !hasAvailableVariant);
    if (soldOutLabel) soldOutLabel.hidden = available;

    item.dataset.available = available ? "true" : "false";
    updateSelectedState(item);
  }

  function updatePrice(item, variant) {
    if (!variant) return;
    const priceValue = displayVariantPrice(variant);
    const price = formatPrice(priceValue);
    const comparePriceValue = displayVariantCompareAtPrice(variant);
    const hasComparePrice = comparePriceValue > priceValue;
    const effectiveDiscountPercent = displayVariantEffectiveDiscountPercent(variant);

    item.querySelectorAll(selectors.priceCurrent).forEach((node) => {
      node.textContent = price;
    });
    item.querySelectorAll(selectors.priceCompare).forEach((node) => {
      node.textContent = hasComparePrice ? formatPrice(comparePriceValue) : "";
      node.hidden = !hasComparePrice;
    });
    item.querySelectorAll(selectors.effectiveDiscountPercent).forEach((node) => {
      node.textContent = String(effectiveDiscountPercent);
    });
    item.querySelectorAll(selectors.effectiveDiscountBadge).forEach((node) => {
      node.hidden = effectiveDiscountPercent <= 0;
    });
  }

  function updateImage(item, variant) {
    const image = item.querySelector(selectors.image);
    const imageUrl = variantImage(variant);

    if (!image || !imageUrl) return;

    image.src = imageUrl;
    image.removeAttribute("srcset");
    if (variant.featured_image && variant.featured_image.alt) {
      image.alt = variant.featured_image.alt;
    }
  }

  function updateSizeOptionAvailability(item) {
    const picker = item.querySelector(selectors.sizePicker);
    if (!picker) return;

    const colorValue = selectedColor(item);
    const colorPosition = optionPositionFromPicker(item, selectors.colorPicker);
    const sizePosition = optionPositionFromPicker(item, selectors.sizePicker);
    const productData = parseProductData(item);
    if (!productData || !Array.isArray(productData.variants)) return;

    picker.querySelectorAll(selectors.sizeOption).forEach((option) => {
      const variant = productData.variants.find((candidate) => {
        const matchesSize = optionMatches(variantOption(candidate, sizePosition), option.dataset.optionLabel);
        const matchesColor = !colorPosition || !colorValue || optionMatches(variantOption(candidate, colorPosition), colorValue);
        return matchesSize && matchesColor;
      });
      option.classList.remove("is-sold-out");
      option.dataset.available = "true";
      option.disabled = false;
      option.removeAttribute("aria-disabled");
      if (variant) {
        option.dataset.variantId = variant.id;
      } else {
        delete option.dataset.variantId;
      }
    });
  }

  function updateColorOptionAvailability(item) {
    const picker = item.querySelector(selectors.colorPicker);
    if (!picker) return;

    const sizeValue = selectedSize(item);
    const sizePosition = optionPositionFromPicker(item, selectors.sizePicker);
    const colorPosition = optionPositionFromPicker(item, selectors.colorPicker);
    const productData = parseProductData(item);
    if (!productData || !Array.isArray(productData.variants)) return;

    picker.querySelectorAll(selectors.colorOption).forEach((option) => {
      const variant = productData.variants.find((candidate) => {
        const matchesColor = optionMatches(variantOption(candidate, colorPosition), option.dataset.optionLabel);
        const matchesSize = !sizePosition || !sizeValue || optionMatches(variantOption(candidate, sizePosition), sizeValue);
        return matchesColor && matchesSize;
      });
      const available = !!(variant && variant.available);
      updateOptionAvailability(option, available);
      if (variant) {
        option.dataset.variantId = variant.id;
      } else {
        delete option.dataset.variantId;
      }
    });
  }

  function updateItemVariant(item, preferredVariant) {
    let variant = preferredVariant || findAvailableVariant(item, selectedSize(item), selectedColor(item));
    if (!variant) return;

    const sizePosition = optionPositionFromPicker(item, selectors.sizePicker);
    const colorPosition = optionPositionFromPicker(item, selectors.colorPicker);
    const colorValue = colorPosition ? variantOption(variant, colorPosition) : selectedColor(item);
    const selectedColorOption = item.querySelector(`${selectors.colorOption}[data-option-label="${safeOptionSelector(colorValue)}"]`);

    if (sizePosition) updateSelectedSize(item, variantOption(variant, sizePosition));
    if (colorPosition) {
      updateSelectedColor(
        item,
        colorValue,
        swatchValueFromOption(selectedColorOption),
        swatchFocalPointFromOption(selectedColorOption)
      );
    }

    const variantInput = item.querySelector(selectors.variantInput);
    if (variantInput) variantInput.value = variant.id;

    updateAvailability(item, variant);
    updatePrice(item, variant);
    updateImage(item, variant);
    updateSizeOptionAvailability(item);
    updateColorOptionAvailability(item);
  }

  function productInfoForForm(form) {
    return form ? form.closest(".m-main-product--info") : null;
  }

  function rootForForm(form) {
    return form ? form.querySelector(selectors.root) : null;
  }

  function getMainProductVariant(form) {
    const productInfo = productInfoForForm(form);
    const productId = productInfo && productInfo.querySelector("[data-product-id]")?.dataset.productId;
    const variantId = form && form.querySelector('[name="id"]')?.value;
    const productData = productId && window._themeProducts && window._themeProducts[productId];

    if (!productData || !Array.isArray(productData.variants)) return null;
    return productData.variants.find((variant) => String(variant.id) === String(variantId)) || null;
  }

  function selectedProductOptionValue(form, optionPosition) {
    const productInfo = productInfoForForm(form);
    const optionGroup = productInfo && productInfo.querySelectorAll("variant-picker .m-product-option__inner")[optionPosition - 1];
    if (!optionGroup) return "";

    const select = optionGroup.querySelector("select");
    if (select) return select.value;

    const checkedInput = optionGroup.querySelector("input:checked");
    if (checkedInput) return checkedInput.value;

    const selectedValue = optionGroup.querySelector("[data-selected-value]");
    return selectedValue ? selectedValue.dataset.selectedValue || selectedValue.textContent.trim() : "";
  }

  function syncComplementaryProductSize(item, sizeValue) {
    if (!sizeValue) return;

    const sizePosition = optionPositionFromPicker(item, selectors.sizePicker);
    if (!sizePosition) return;

    const variant = findAvailableVariant(item, sizeValue, selectedColor(item));
    if (!variant) return;

    updateItemVariant(item, variant);
  }

  function syncComplementarySizesFromSource(form) {
    const root = rootForForm(form);
    if (!root || !root.hasAttribute("data-complementary-sync-source-size")) return;

    const sourceSizePosition = Number(root.dataset.complementarySourceSizePosition || 0);
    const sourceSizeValue = selectedProductOptionValue(form, sourceSizePosition);
    if (!sourceSizeValue) return;

    root.querySelectorAll(selectors.item).forEach((item) => syncComplementaryProductSize(item, sourceSizeValue));
    updateAddToCartTotal(form);
  }

  function selectedItems(form) {
    const root = rootForForm(form);
    if (!root) return [];

    return [...root.querySelectorAll(selectors.item)]
      .filter((item) => {
        const toggle = item.querySelector(selectors.toggle);
        const variantInput = item.querySelector(selectors.variantInput);
        return toggle && toggle.checked && !toggle.disabled && variantInput && variantInput.value && !variantInput.disabled;
      })
      .map((item) => {
        const variantInput = item.querySelector(selectors.variantInput);
        const variant = findVariantById(item, variantInput.value);
        return {
          id: Number(variantInput.value),
          quantity: 1,
          properties: {
            _pp_add_on: "true",
            _pp_add_on_handle: item.dataset.complementaryProductHandle || "",
            _pp_add_on_source_handle: item.dataset.complementarySourceProductHandle || "",
          },
          price: displayVariantPrice(variant),
          compare_at_price: displayVariantCompareAtPrice(variant),
        };
      });
  }

  function hasUnavailableSelectedAddOns(form) {
    const root = rootForForm(form);
    if (!root) return false;

    return [...root.querySelectorAll(selectors.item)].some((item) => {
      const toggle = item.querySelector(selectors.toggle);
      return toggle && toggle.checked && !toggle.disabled && item.dataset.available === "false";
    });
  }

  function updateAddOnStockWarning(form, shouldShow) {
    const button = form && form.querySelector('[name="add"]');
    if (!button) return;

    let warning = form.querySelector(totalSelectors.stockWarning);
    if (!warning) {
      warning = document.createElement("p");
      warning.className = "product-complementary-products__stock-warning";
      warning.setAttribute("data-complementary-stock-warning", "");
      warning.setAttribute("role", "status");
      warning.hidden = true;
      warning.textContent = stockWarningText;

      const buttonWrapper = button.closest(".m-product-form--wrapper");
      if (buttonWrapper) {
        buttonWrapper.insertAdjacentElement("afterend", warning);
      } else {
        button.insertAdjacentElement("afterend", warning);
      }
    }

    warning.hidden = !shouldShow;
  }

  function defaultAddToCartText(button, buttonText) {
    if (!buttonText) return "";
    if (!buttonText.dataset.complementaryDefaultText) {
      buttonText.dataset.complementaryDefaultText = buttonText.textContent.trim();
    }

    return buttonText.dataset.complementaryDefaultText || button?.dataset.atcText || "";
  }

  function updateAddToCartText(button, buttonText, itemCount) {
    if (!buttonText) return;

    if (itemCount > 1) {
      const template = button?.dataset.atcBundleTextTemplate || "Add [count] items to cart";
      buttonText.textContent = template.replace("[count]", String(itemCount));
      return;
    }

    buttonText.textContent = defaultAddToCartText(button, buttonText);
  }

  function updateAddToCartTotal(form) {
    const root = rootForForm(form);
    const button = form && form.querySelector('[name="add"]');
    const buttonText = button && button.querySelector(".m-add-to-cart--text");
    if (!root || !button || !buttonText) return;

    defaultAddToCartText(button, buttonText);

    const addOnItems = selectedItems(form);
    const mainVariant = getMainProductVariant(form);
    const quantity = Math.max(Number(form.querySelector('[name="quantity"]')?.value || 1), 1);
    const selectedCount = addOnItems.length;

    updateAddOnStockWarning(form, hasUnavailableSelectedAddOns(form));

    if (!selectedCount || !mainVariant) {
      const total = button.querySelector(totalSelectors.wrapper);
      if (total) total.hidden = true;
      updateAddToCartText(button, buttonText, 0);
      button.classList.remove("has-complementary-total");
      return;
    }

    let total = button.querySelector(totalSelectors.wrapper);
    if (!total) {
      total = document.createElement("span");
      total.className = "product-complementary-products-atc-total";
      total.setAttribute("data-add-to-cart-total", "");
      total.hidden = true;
      total.innerHTML = [
        '<span class="product-complementary-products-atc-total__prices">',
        '<span class="product-complementary-products-atc-total__price" data-add-to-cart-total-price></span>',
        '<span class="product-complementary-products-atc-total__compare" data-add-to-cart-compare-price hidden></span>',
        '</span>',
      ].join("");
      buttonText.insertAdjacentElement("afterend", total);
    }

    const mainPriceWrapper = form.closest("product-info")?.querySelector(".m-price");
    const mainFinalPrice = window.NelpandaFinalPrice && window.NelpandaFinalPrice.projectVariant(
      mainVariant,
      mainPriceWrapper && mainPriceWrapper.dataset.finalPriceRate
    );
    const mainProductPrice = mainFinalPrice && mainFinalPrice.active ? mainFinalPrice.price : Number(mainVariant.price || 0);
    const mainPrice = window.NelpandaFinalPrice?.applyOrderDiscount(
      mainProductPrice,
      undefined,
      mainPriceWrapper?.dataset.productDiscountEligible !== 'false'
    ) ?? mainProductPrice;
    const mainComparePrice = mainFinalPrice && mainFinalPrice.active
      ? mainFinalPrice.referencePrice
      : Number(mainVariant.compare_at_price || 0);
    const price = mainPrice * quantity + addOnItems.reduce((sum, item) => sum + item.price, 0);
    const allItemsHaveComparePrice =
      mainComparePrice > mainPrice && addOnItems.every((item) => item.compare_at_price > item.price);
    const comparePrice =
      mainComparePrice * quantity + addOnItems.reduce((sum, item) => sum + item.compare_at_price, 0);
    const totalItemCount = quantity + addOnItems.reduce((sum, item) => sum + Number(item.quantity || 1), 0);

    const count = total.querySelector(totalSelectors.count);
    const compare = total.querySelector(totalSelectors.comparePrice);
    const priceNode = total.querySelector(totalSelectors.totalPrice);

    if (count) {
      count.textContent = String(totalItemCount);
      count.setAttribute("aria-label", totalItemCount === 1 ? "1 item" : `${totalItemCount} items`);
      count.hidden = true;
    }
    if (compare) {
      compare.textContent = formatPrice(comparePrice);
      compare.hidden = !allItemsHaveComparePrice || !(comparePrice > price);
    }
    if (priceNode) priceNode.textContent = formatPrice(price);
    updateAddToCartText(button, buttonText, totalItemCount);
    total.hidden = false;
    button.classList.add("has-complementary-total");
  }

  function setSizeFromOption(option) {
    const item = option.closest(selectors.item);
    if (!item) return;

    const variant = findAvailableVariant(item, option.dataset.optionLabel, selectedColor(item));
    updateItemVariant(item, variant);
    closeList(item.querySelector(selectors.sizeToggle), item.querySelector(selectors.sizeList));
    updateAddToCartTotal(item.closest("form"));
  }

  function setColorFromOption(option) {
    const item = option.closest(selectors.item);
    if (!item) return;

    const variant = findAvailableVariant(item, selectedSize(item), option.dataset.optionLabel);
    updateItemVariant(item, variant);
    closeList(item.querySelector(selectors.colorToggle), item.querySelector(selectors.colorList));
    updateAddToCartTotal(item.closest("form"));
  }

  function initRoot(root) {
    const form = root.closest("form");
    root.querySelectorAll(selectors.item).forEach((item) => {
      updateItemVariant(item);
      updateSelectedState(item);
    });
    if (form) {
      syncComplementarySizesFromSource(form);
      updateAddToCartTotal(form);
    }
  }

  function initAll() {
    document.querySelectorAll(selectors.root).forEach(initRoot);
  }

  document.addEventListener("change", (event) => {
    if (event.target.matches(selectors.toggle) || event.target.matches('[name="quantity"]')) {
      if (event.target.matches(selectors.toggle)) updateSelectedState(event.target.closest(selectors.item));
      const form = event.target.closest("form");
      if (form) updateAddToCartTotal(form);
    }
  });

  document.addEventListener("input", (event) => {
    if (event.target.matches('[name="quantity"]')) {
      const form = event.target.closest("form");
      if (form) updateAddToCartTotal(form);
    }
  });

  document.addEventListener("click", (event) => {
    const sizeToggle = event.target.closest(selectors.sizeToggle);
    if (sizeToggle) {
      event.preventDefault();
      const item = sizeToggle.closest(selectors.item);
      toggleList(sizeToggle, item && item.querySelector(selectors.sizeList));
      return;
    }

    const colorToggle = event.target.closest(selectors.colorToggle);
    if (colorToggle) {
      event.preventDefault();
      const item = colorToggle.closest(selectors.item);
      toggleList(colorToggle, item && item.querySelector(selectors.colorList));
      return;
    }

    const sizeOption = event.target.closest(selectors.sizeOption);
    if (sizeOption) {
      event.preventDefault();
      setSizeFromOption(sizeOption);
      return;
    }

    const colorOption = event.target.closest(selectors.colorOption);
    if (colorOption) {
      event.preventDefault();
      setColorFromOption(colorOption);
      return;
    }

    if (!event.target.closest(`${selectors.sizePicker}, ${selectors.colorPicker}`)) {
      closeAllLists();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeAllLists();
  });

  document.addEventListener("nelpanda:order-discount", initAll);

  if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.variantChange, (event) => {
      const sectionId = event && event.data && event.data.sectionId;
      const productInfo = sectionId ? document.getElementById(`MainProduct-${sectionId}`) : null;
      const form = productInfo && productInfo.querySelector("product-form form");
      if (!form) return;
      setTimeout(() => syncComplementarySizesFromSource(form), 0);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  window.NelpandaComplementaryProducts = {
    getSelectedItems: selectedItems,
    hasUnavailableSelectedAddOns,
    syncComplementarySizesFromSource,
    updateAddToCartTotal,
  };
})();
